module.exports = __webpack_public_path__ + "img/lavalife.e32f680.png";